<template>
    <div>
    <el-tabs v-model="tabsKey"
        type="card">
        <el-tab-pane name="user" label="美容師">
            <user />
        </el-tab-pane>
        <el-tab-pane name="shop" label="店櫃">
            <shop />
        </el-tab-pane>
    </el-tabs>
    
    </div>
</template>

<script>
    import shop from './Performance/shop'
    import User from './Performance/user'
    export default {
        name: 'performance',
        components: {
            shop,
            User
        },
        data() {
            return {
              tabsKey: 'user',
            }
        },
       
    }
</script>